import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ValueSetDialogIncExc from './ValueSetDialogIncExc';
// import MuiAlert from '@material-ui/lab/Alert';
// import { GlobalContext } from '../contexts/GlobalContext';

// import './CodeSystemDialogRows.css';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: "100%",
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        flex: 0.2,
    },
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            className="vsTabPanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}

export default function ValueSetDialogCompose(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        if (props) {
        }
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function includeTabs() {
        return props.compose.include.map((x, index) =>
            (
                <Tab label={"Include #" + (index + 1)} id={"vertical-tab-inc" + index} aria-controls={"vertical-tabpanel-inc" + index} key={"t" + index} />
            )
        )
    }

    function excludeTabs() {
        var cntExclude = (props.compose.exclude) ? props.compose.exclude.length : 0;

        if (cntExclude > 0) {
            return props.compose.exclude.map((x, index) =>
                (
                    <Tab label={"Exclude #" + (index + 1)} id={"vertical-tab-inc" + index} aria-controls={"vertical-tabpanel-inc" + index} />
                )
            )
        }
        return ''

    }

    function vsTabPanelsInclude() {
        var resp = props.compose.include.map((x, index) =>
            (
                <TabPanel value={value} index={index} key={"in" + index}>
                    <ValueSetDialogIncExc rule={props.compose.include[index]} />
                </TabPanel>
            )
        )
        return resp;
    }

    function vsTabPanelsExclude() {
        var offset = props.compose.include.length;
        var cntExclude = (props.compose.exclude) ? props.compose.exclude.length : 0;
        var resp = '';

        if (cntExclude > 0) {
            resp = props.compose.exclude.map((x, index) =>
                (
                    <TabPanel value={value} index={index + offset} key={"ex" + index}>
                        <ValueSetDialogIncExc rule={props.compose.exclude[index]} />
                    </TabPanel>
                )
            )
        }

        return resp;
    }


    function displayTable() {
        // console.log("v", value);
        return (
            <div className={classes.root}>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    className={classes.tabs}
                >
                    {includeTabs()}
                    {excludeTabs()}
                </Tabs>
                {vsTabPanelsInclude()}
                {vsTabPanelsExclude()}
            </div>
        )
    }

    return (
        displayTable()
    );
}
